import { FileUpload } from '@/types/file-upload.types';
import {
  BusinessVerification,
  VerificationService,
} from '@clearbanc/service-classes/verification-service';

interface DocumentUploadParams {
  isLexisNexisDDPEnabled: boolean;
  businessVerification: BusinessVerification;
  businessUploads: FileUpload[];
}

/**
 * Determines if document uploads are required based on business verification status
 * @param params - Parameters for document upload requirement evaluation
 * @returns boolean indicating if document uploads are required
 */
export function areDocumentUploadsRequired(
  params: DocumentUploadParams,
): boolean {
  const { isLexisNexisDDPEnabled, businessVerification, businessUploads } =
    params;
  return VerificationService.areBusinessDocumentsRequired({
    isLexisNexisDDPEnabled,
    businessUploads: businessUploads as any,
    latestBusinessVerification: businessVerification,
  });
}

export function areDocumentUploadsHidden(
  params: DocumentUploadParams,
): boolean {
  const { isLexisNexisDDPEnabled, businessVerification, businessUploads } =
    params;

  if (!isLexisNexisDDPEnabled) {
    return false;
  }

  return (
    !VerificationService.hasBusinessUploadedRequiredVerificationDocs(
      businessUploads as any,
    ) &&
    !VerificationService.hasHardFailedBusinessVerification(
      businessVerification,
    ) &&
    !VerificationService.hasPassedBusinessVerification(businessVerification)
  );
}
